
import React from 'react';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyles, mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { DetailsList, DetailsListLayoutMode, DetailsRow, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { useDispatch, useSelector  } from 'react-redux';

import ConditionOperator from '../../common/common/ConditionOperator';

import {
    DialogConfirm,
    existsModule,
    IfComp
} from '../../core';

// ToDo: Circular dependency
import { useDataModelDefinition } from '../../data';

import { sagas as sagasMap } from '../../map';
import {
    getMapDataMapping,
    useDataProjectId
} from '../../project';
import {getActions as searchGetAction} from '../sagas';

import { getUi } from '../reducers';
import { getAttrConditions, getSearchData } from '../reducers/ui';

const Searching = () => {
    const classNames = mergeStyleSets({
        root: {
            padding: 4
        }
    });

    return (
        <Stack className={classNames.root}>
            <div>Vyhledávám...</div>
        </Stack>
    );
}

const SearchResultCount = ({searchResult}) => {

    const classNames = mergeStyleSets({
        SearchResultCount: {
            padding: '10px 0 10px 0'
        },
    });

    const countText = (searchResult.totalCount)
        ? `Zobrazeno ${searchResult.count} z ${searchResult.totalCount} *`
        : `Počet výsledků: ${searchResult.count}`;

    const title = (searchResult.totalCount)
        ? `Zobrazeno prvních ${searchResult.count} výsledků z celkového počtu ${searchResult.totalCount} výsledků`
        : ``;

    return (
        <div className={classNames.SearchResultCount} title={title}>{countText}</div>
    );
}

const SearchResultDetail = (props) => {

    const classNames = mergeStyleSets({
        root: {
            boxSizing: 'border-box',
            height: '100%',
            minHeight: 0,
            overflow: 'hidden',
            padding: 4
        },
        results: {
            overflowY: 'scroll',
            height: 0
        },
        detailIcon: {
            fontSize: '16px',
            height: '20px',
            width: '32px',
            cursor: 'pointer'
        }
    });

    const dispatch = useDispatch();
    const mapActions = sagasMap.getActions(dispatch);
    const searchAction = searchGetAction(dispatch);

    const projectId = useDataProjectId();
    // ToDo: Circular dependency
    const dataModelDefinition = useDataModelDefinition(projectId);

    const attrConditions = useSelector(state => getAttrConditions(getUi(state.search)));
    const searchData = useSelector(state => getSearchData(getUi(state.search)));


    const columns = [{
        key: 'title',
        fieldName: 'title',
        minWidth: 150
    }, {
        key: 'detail',
        minWidth: 20
    }];

    React.useEffect(() => {
        if (props.searchResult) {
            addPins();
        }
    }, []);

    const getItemLayerId = (item) => {
        return item._layerId || ((item._info || props.searchResult.info) ? `search:${props.searchResult.queryId}` : null);
    }

    const getItemAttributes = (item) => {
        return {
            ...item._attrs,
            _geom: item.geom,
            _info: item._info || props.searchResult.info,
            _title: item.title
        };
    }

    const addPins = () => {
        mapActions.addCommand(

            'SEARCH_ADD_PINS',
            {
                items: props.searchResult.objects.map(item => {
                    return {
                        ...item,
                        _info: props.searchResult.info,
                        _queryId: props.searchResult.queryId
                    };
                })
            }
        );
    }

    const canSendToDatawin = () => {
        let can = existsModule('data');
        if (can && props.searchResult.objects.length > 0) {
            const dataSourceId = props.mapDataMapping.map[props.searchResult.objects[0]._layerId];

            let hasOperationGet = false;
            if (dataModelDefinition.dataModelDefinition) {
                hasOperationGet = dataModelDefinition.dataModelDefinition.items.reduce((previous, current) => {
                    return (current.id === dataSourceId)
                        ? (current.operations.get && (current.$template !== true))
                        : previous;
                }, false);
            }

            can = can && !!dataSourceId && hasOperationGet;
        }
        return can;
    }

    const onItemInvoked = (item) => {
        mapActions.addCommand(
            'ZOOM_FEATURE',
            {
                geoJson: item.geom
            }
        );
    }

    const onRenderItemColumn = (item, index, column) => {
        switch (column.key) {
            case 'detail':
                if (item._attrs) {
                    return renderDetailItemColumn(item, index, column);
                } else {
                    return renderNormalItemColumn(item, index, column);
                }
            default:
                return renderNormalItemColumn(item, index, column);
            }
    }

    const onRenderRow = (props, defaultRenderer) => {
        return (
            <DetailsRow {...props}
                onMouseEnter={() => {onRowMouseEnter(props.item)}}
                onMouseLeave={() => {onRowMouseLeave(props.item)}}
            />
        );
    }

    const onRowMouseEnter = (item) => {
        mapActions.addCommand(
            'HIGHLIGHT_FEATURE',
            {
                geoJson: item.geom
            }
        );
    }

    const onRowMouseLeave = (item) => {
        mapActions.addCommand(
            'HIGHLIGHT_FEATURE', {geoJsons: []}
        );
    }

    const onSearchResultClear = () => {
        searchAction.clearSearchResult();
    }

    const onSearchResultDatawinParams = async () => {
        if (props.searchResult.objects.length > 0) {

            let attributes = {};
            let existsNotEqualOperator = false;

            Object.keys(attrConditions).forEach(key => {
                const attribute = attrConditions[key];
                if (attribute && attribute.operator === ConditionOperator.EQUAL) {
                    attributes[key] = attribute.value;
                } else {
                    existsNotEqualOperator = true;
                }
            });

            let flag = true;
            if (existsNotEqualOperator) {
                flag = await DialogConfirm.show(
                    `Do datového okna se přenáší pouze podmínky s operátorem = <br>` +
                    `Aktuální vyhledávání obsahuje podmínky s jinými operátory. <br>` +
                    `Opravdu chcete pokračovat do datového okna ?`
                );
            }

            if (flag) {
                MultiSceneForApp.executeCommand({
                    command: 'data.setDatawinFetchAttributes',
                    dataModelItemId: props.mapDataMapping.map[props.searchResult.objects[0]._layerId],
                    attributes: attributes,
                    geom: searchData.geom
                });

                props.appActions.setUiValue('activeWindow', 'data');
            }
        }
    }

    const onSearchResultDatawinResult = () => {
        if (props.searchResult.objects.length > 0) {

            MultiSceneForApp.executeCommand({
                command: 'data.setDatawinObjectList',
                mode: 'SET',
                dataModelItemId: props.mapDataMapping.map[props.searchResult.objects[0]._layerId],
                objectList: props.searchResult.objects.map(item => {
                    return {
                        layerId: item._layerId,
                        attributes: {
                            ...item._attrs,
                            _geom: item.geom
                        }
                    }
                })
            });

            props.appActions.setUiValue('activeWindow', 'data');
        }
    }

    const onSearchResultZoom = () => {
        mapActions.addCommand(
            'ZOOM_FEATURE',
            {
                geoJson: props.searchResult.extent
            }
        );
    }

    const renderNormalItemColumn = (item, index, column) => {
        const fieldContent = (column.onGetValue)
            ? column.onGetValue(item)
            : item[column.fieldName];

        let styles = {};

        return (
            <span
                data-selection-disabled={true}
                title={(column.key === 'title') ? fieldContent : undefined}
                className={mergeStyles(styles)}>
            {fieldContent}
            </span>
        );
    }

    const renderDetailItemColumn = (item, index, column) => {

        const onClick = () => {
            if (props.onObjectInfo) {
                props.onObjectInfo(
                    getItemLayerId(item),
                    getItemAttributes(item),
                    'search'
                );
            }
        }

        return (
            <span data-selection-disabled={true}>
                <ActionButton
                    title="Zobrazit detail objektu"
                    onClick={onClick}
                    iconProps={{iconName: 'Info'}}
                    className={classNames.detailIcon}
                />
            </span>
        );
    }

    return (
        <Stack verticalFill className={classNames.root}>
            <Stack horizontal>
                <Stack.Item grow={1}>
                    <SearchResultCount searchResult={props.searchResult} />
                </Stack.Item>
                <Stack.Item>
                    <IfComp cond={canSendToDatawin()}>
                        <ActionButton
                            title="Přenést parametry vyhledávání do Datového okna"
                            onClick={onSearchResultDatawinParams}
                            iconProps={{iconName: 'CheckList'}}
                            styles={{root:{padding: 0}}}
                        />
                        <ActionButton
                            title="Přenést zobrazené výsledky vyhledávání do Datového okna"
                            onClick={onSearchResultDatawinResult}
                            iconProps={{iconName: 'CustomList'}}
                            styles={{root:{padding: 0}}}
                        />
                    </IfComp>
                    <ActionButton
                        title="Zobrazit výsledky vyhledávání v mapě"
                        onClick={onSearchResultZoom}
                        iconProps={{iconName: 'FitPage'}}
                        styles={{root:{padding: 0}}}
                    />
                    <ActionButton
                        title="Vymazat výsledky vyhledávání"
                        onClick={onSearchResultClear}
                        iconProps={{iconName: 'Clear'}}
                        styles={{root:{padding: 0}}}
                    />
                </Stack.Item>
            </Stack>
            <Stack.Item grow={1} className={classNames.results} data-is-scrollable="true">
                <DetailsList
                    items={props.searchResult.objects}
                    compact={true}
                    columns={columns}
                    isHeaderVisible={false}
                    selectionMode={SelectionMode.none}
                    layoutMode={DetailsListLayoutMode.justified}
                    onItemInvoked={onItemInvoked}
                    onRenderRow={onRenderRow}
                    onRenderItemColumn={onRenderItemColumn}
                />
            </Stack.Item>
        </Stack>
    );
}

const SearchResult = (props) => {
    const dispatch = useDispatch();
    const mapActions = sagasMap.getActions(dispatch);

    const mapDataMapping = useSelector(state => getMapDataMapping(state.project));
    const searchResult = useSelector(state => state.search.search.searchResult);
    const searching = useSelector(state => state.search.search.searching);

    React.useEffect(() => {
        return () => {
            mapActions.addCommand(
                'HIGHLIGHT_FEATURE', {geoJsons: []}
            );
        };
    }, [])

    return (searching)
        ? <Searching />
        : (
            (searchResult)
                ? <SearchResultDetail
                    appActions={props.appActions}
                    mapDataMapping={mapDataMapping}
                    searchResult={searchResult}
                    onObjectInfo={props.onObjectInfo}
                    onMoveToDatawin={props.onMoveToDatawin}
                />
                : null
        );
}

export default SearchResult;
